export const stringify = (obj) => {
    const entries = Object.entries(obj);
    const encodeds = entries.map(([name, value]) => {
        const encoded = encodeURIComponent(String(value));
        return `${name}=${encoded}`;
    });
    return encodeds.join("&");
};
